/**
 * Hook + context for the IA portal tenant branding provider.
 *
 * Lives in its own file so the provider component file can stay
 * Fast-Refresh-friendly (`react-refresh/only-export-components`
 * fires when a module exports both a component and a hook).
 */

import * as React from "react";
import type { BrandingPublic } from "@/lib/branding/types";

export interface TenantBrandingContextValue {
  branding: BrandingPublic | undefined;
  isLoading: boolean;
}

export const TenantBrandingContext = React.createContext<TenantBrandingContextValue>({
  branding: undefined,
  isLoading: false,
});

export function useTenantBrandingContext(): TenantBrandingContextValue {
  return React.useContext(TenantBrandingContext);
}
